<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить отзыв</span>
              <span v-else> <div>Создать отзыв</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('person')"
              :error-messages="getError('person')"
              :items="selectors.person"
              label="Оппонент"
              v-model="value.person"
              no-data-text ="Нет данных"
            >
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="addPerson = true"
                >
                  <v-list-tile-action>
                    <v-icon>add</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>

            <v-autocomplete
              :disabled="disableCandidateCase"
              :error="hasError('candidateCase')"
              :error-messages="getError('candidateCase')"
              :items="selectors.candidateCase"
              label="Аттестационное дело соискателя"
              v-model="value.candidateCase"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <FileInput
              v-bind:fieldLabel="'отзыв'"
              v-bind:field="'review'"
              @updateFile="updateFile"
              v-bind:file=value.review
              v-bind:error="hasError('review')"
              v-bind:error_messages="getError('review')"
            ></FileInput>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>

          </v-card-text>
          <v-dialog @input="loadAddPerson" v-model="addPerson" width="500" persistent>
            <Person @addItem="loadAddPerson"
                    @ended="addPerson = false"
                    @refreshItem="loadAddPerson"
                    v-if="addPerson"
            >
            </Person>
          </v-dialog>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
  import {makeGetRequest, makePostRequestFile} from "../../../../../helper";
  import FileInput from "../../../../diss/components/FileInput"
  import Person from "./Person"
  export default {
    name: "Scientific_boss",
    props: [
      "id" ,"candidateCase","person","review","disable"
    ],
    mixins: [UserDataFormMixin],
    components: {FileInput,Person},
    data() {
      return {
        addPerson:false,

        URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/case/models/scientific_boss/",
        URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/case/models/scientific_boss/<id>/",
        selectors:{
          candidateCase: [],
          person: [],
        },
        disableCandidateCase : this.disable || false,
        value: {
          id: this.id || '',
          candidateCase: this.candidateCase || '',
          person: this.person || '',
          review: this.review ||null,
        },
      }
    },
    created() {
      //console.log(this.$route.params.id)
      if (this.disable){
        this.value.candidateCase = Number(this.$route.params.id)
        //console.log(this.value)
      }
      let  url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/person/"
      this.load(this, url,'person')

      url =  process.env.VUE_APP_API_HOST +"council/admin/case/selectors/candidate_case/"
      this.load(this, url,'candidateCase')

    },
    methods: {
      loadAddPerson(){
        this.addPerson = false;
        this.selectors.person= [];
        let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/";
        this.load(this, url, "person")
      },
      updateFile(item) {
        this.value[item.field] = item.file;
      },
      closeDialog() {
        this.$emit('ended', '')
      },
      apply: function () {

        let url = this.URL_CREATE;
        let method = 'POST'

        if (this.id !== undefined) {
          method = 'PUT'
          url = this.URL_UPDATE.replace('<id>', this.id);
        }

        let data = Object.assign({}, this.value);

        var formData = new FormData();

        for (var key in data) {
          if (data[key] !== undefined && data[key] !== null)
            formData.append(key, data[key])
        }

        let status = true;
        makePostRequestFile(url, formData, method)
          .then(resp => {
            if (!resp.ok) {
              status = false;
            }
            return resp.json()
          })
          .then(json => {

            if (status) {
              this.$emit('addItem', json);
            } else {
              this.receiveErrors(json);
            }

          })

      },
      load: function (app, url,field) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[field].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url,field);
          });
      },
      text: item => item.name[0].text,

    },
  }
</script>

<style scoped>

</style>
